<header class="pdplg-header">
  <div class="pdplg-container">
    <div class="pdplg-logo pdplg-withbg">
      <img src="../assets/images/paydayportal-logo-2026.svg" alt="logo" />
    </div>

    <div class="pdplg-navigation">
      <div class="pdplg-btn-group pdplg-TopRightBtn">
        <div class="pdplg-logo-right">
          <img src="../assets/images/brinker_pantone.png"
               class="pdplg-logo_mobile" style="height:50px; min-width: 150px" />
        </div>
        <div class="sso-text">
          <span>
            {{ "login.ssoDescription" | translate }}
          </span>
        </div>
        <div class="pdplg-contactform pdplg-login-btn-container sso-container">
          <div [class.disabled_opacity-no-color]="loading">
            <a href="#"
               (click)="oktaLogin($event)"
               class="pdplg-site-btn-sso sso-login">{{ "login.brinkerSSO" | translate }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="pdplg-logo-right">
      <a href="https://gratuitysolutions.com/index.html">
        <img
          src="../assets/images/gratuity_solutions_powered_by.png"
          class="pdplg-logo_mobile"
        />
      </a>
    </div>
  </div>


  <p-dialog
    [(visible)]="userAgreementDialogVisible"
    [header]="'Please accept user agreement'"
    [draggable]="false"
    [modal]="true"
    [closable]="true"
  >
    <ng-template pTemplate="content">
      <p>{{ userAgreementDialogMessage }}</p>
    </ng-template>
  </p-dialog>

  <p-dialog
    header="{{ dialogHeader }}"
    [(visible)]="showDialog"
    [modal]="true"
    [style]="{ width: dialogWidth }"
    [draggable]="false"
    [resizable]="false"
  >
    <manage-agreement
      *ngIf="agreementURl"
      [agreementURl]="agreementURl"
    ></manage-agreement>

    <p-footer>
      <button
        type="button"
        pButton
        icon="pi pi-print"
        (click)="print()"
        *ngIf="agreementURl"
        label="{{ dialogCancel }}"
        class="ui-button-secondary"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-check"
        (click)="respondToUserAgreement(true)"
        *ngIf="agreementURl"
        label="{{ dialogApply }}"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        class="undo"
        (click)="respondToUserAgreement(false)"
        *ngIf="agreementURl"
        label="Disagree"
      ></button>
    </p-footer>
  </p-dialog>
</header>


<!--<embed [src]="contentURL"
       style="width:100%; height: calc(100vh - 120px)"
       onerror="alert('URL invalid !!');" />-->

<!--<BODY style="overflow:hidden; height:100%;">

  <object [data]="contentURL" type="text/html" style="float:left;width:230px;height:100%"></object>

</BODY>-->

<iframe
  class="pdplg-iframe"
  id="iframeURL"
  name="iframeURL"
  [src]="contentURL"
  allowtransparency="true"
  allowfullscreen
  scrolling="yes"
  style="width: 100%; border: none; height: calc(100vh - 10px)"
></iframe>
